import React, { useEffect, useRef } from 'react';
import './ProposicoesValores.css';

const cards = [
  {
    title: 'Missão',
    text:
      'Oferecer soluções em armazenagem eficientes e seguras, desenvolvendo projetos personalizados que otimizam espaço e melhoram o desempenho operacional dos nossos clientes.',
  },
  {
    title: 'Visão',
    text:
      'Ser referência em soluções de armazenagem, reconhecida pela qualidade, inovação e resultados entregues aos clientes.',
  },
  {
    title: 'Valores',
    text:
      'Compromisso com o cliente, qualidade em cada projeto, transparência nas relações, foco em resultados e busca constante por melhoria e inovação.',
  },
];

function ProposicoesValores() {
  const titleRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('pv__animate--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    if (titleRef.current) observer.observe(titleRef.current);
    cardRefs.current.forEach((el) => { if (el) observer.observe(el); });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="pv">
      <div className="pv__container">
        <h2
          className="pv__title pv__animate pv__animate--up"
          ref={titleRef}
        >
          Propósito e Valores
        </h2>

        <div className="pv__cards">
          {cards.map((card, i) => (
            <div
              key={card.title}
              className="pv__card pv__animate pv__animate--up"
              ref={(el) => (cardRefs.current[i] = el)}
              style={{ transitionDelay: `${0.15 + i * 0.15}s` }}
            >
              <h3 className="pv__card-title">{card.title}</h3>
              <p className="pv__card-text">{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProposicoesValores;
